import { useState, useMemo, createContext } from 'react';

interface AccountSheetValue {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const AccountSheetContext = createContext<AccountSheetValue>({
  open: false,
  setOpen: () => {},
});

export default AccountSheetContext;

export function AccountSheetProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);

  const value: AccountSheetValue = useMemo(
    () => ({ open, setOpen }),
    [open, setOpen]
  );

  return <AccountSheetContext.Provider value={value}>
    {children}
  </AccountSheetContext.Provider>;
}

